import { z } from "@/zod";

const projectPeriod = z.object({
  id: z.string().length(26),
  period: z.string().date(),
  store_active: z.boolean(),
});

export const readProjectPeriod = projectPeriod.readonly();
